import ClaimPodcastButton from './ClaimPodcastButton';

export default ClaimPodcastButton;
